var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useEffect, useState, useMemo } from '@max/max';
import View from '@hfe/max-view';
import LinearGradient from '@hfe/max-linear-gradient';
import Sensor from '@max/mbc-sensor';
import { getPlatformType, PlatformType, getAppVersion } from '@nibfe/mkt-env-api';
import { TechStackUtil } from '@nibfe/mkt-common-utils';
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { KNB } from '@nibfe/mkt-common-utils';
import warmUpByBundleNamesFn from "./utils/warmUpByBundleNames/index.web";
import { getCityInfo } from './utils';
import { getCouponConfigMsg, presendRequest, sortCoupon } from './utils/coupon';
import Header from './components/header';
import CouponList from './components/coupon-list';
import { lxBidConfig, amountColorConfig } from './lib/constant';
import AllClaimButton from './components/all-claim-button';
import './index.scss';
import { CouponStatus } from '@nibfe/mkt-coupon-api';
const MagicmemberCoupon = (props) => {
    const { _LXReport, _moduleId, _runtimeInfo, _raptorReport, couponConfig, isShowContainer, bgColor, title, titleColor, secondEntryText, secondEntryColor, secondEntryLink, themeColor = 'default', successTip, overstepTimesTip, receivedIneligibility, soldOutTip, totalFailTip, noPortraitTip, ratelimit, notStartTip, endTip, frequentClickInterval, enableHorizontalScroll, enableAllCoupon, allCouponText, allCouponColor, allCouponTextColor, isDefaultSort } = props || {};
    const toastConfig = {
        successTip,
        overstepTimesTip,
        receivedIneligibility,
        soldOutTip,
        totalFailTip,
        noPortraitTip,
        ratelimit,
        notStartTip,
        endTip,
        frequentClickInterval
    };
    const amountColor = amountColorConfig === null || amountColorConfig === void 0 ? void 0 : amountColorConfig[themeColor];
    const [showComponent, setShowComponent] = useState(false); // 本地PC调试使用设置为true
    const [couponList, setCouponList] = useState([]);
    const [currentTimeMillis, setCurrentTimeMillis] = useState();
    // location信息采用组件初始化时的值，避免券及膨胀弹窗内的经纬度不一致，影响膨胀策略
    const [realLocation, setLocation] = useState({});
    const { queryParams } = _runtimeInfo || {};
    const { hotelchannel = -999 } = queryParams || {};
    const formatCouponConfigRes = useMemo(() => {
        return getCouponConfigMsg(couponConfig);
    }, [couponConfig]);
    // 使用 useMemo 优化排序后的列表
    const sortedCouponList = useMemo(() => {
        return sortCoupon(couponList, isDefaultSort);
    }, [couponList, isDefaultSort]);
    const showAllCalimBtn = useMemo(() => {
        if (!enableAllCoupon)
            return false;
        const hasToUseCoupon = (couponList || []).some(item => item.status === CouponStatus.NotClaimed);
        return hasToUseCoupon;
    }, [enableAllCoupon, couponList]);
    const bizLine = useMemo(() => {
        var _a;
        return ((_a = couponConfig[0]) === null || _a === void 0 ? void 0 : _a.bizLine) || -999;
    }, [couponConfig]);
    const initData = () => __awaiter(void 0, void 0, void 0, function* () {
        const appVersion = getAppVersion();
        const isInEditor = TechStackUtil.isInEditor();
        // 美团app且下届大于等于12.20.400展示组件，画布内也展示
        if (showComponent || isInEditor || [PlatformType.mtApp, PlatformType.mtAppWebView].includes(getPlatformType()) && KNB.Semver.gte(appVersion, '12.20.400')) {
            try {
                const { gpsLocation = {} } = yield getLBSInfo({
                    needLocation: true
                });
                const cityInfo = yield getCityInfo();
                const { lat: actualLatitude, lng: actualLongitude } = gpsLocation || {};
                const { locCityId } = cityInfo || {};
                setLocation({
                    actualLatitude,
                    actualLongitude,
                    locationCityId: locCityId
                });
                const couponKeyArr = couponConfig.map(item => item.couponKey);
                const res = yield presendRequest({
                    campaignKeys: couponKeyArr,
                    pageId: _runtimeInfo === null || _runtimeInfo === void 0 ? void 0 : _runtimeInfo.pageId,
                    moduleId: _moduleId,
                    mmcParams: {
                        actualLatitude,
                        actualLongitude,
                        locationCityId: locCityId
                    }
                }, formatCouponConfigRes, {
                    rootTag: _runtimeInfo === null || _runtimeInfo === void 0 ? void 0 : _runtimeInfo.rootTag
                });
                const { couponList: newCouponList, currentTimeMillis } = res || {};
                setShowComponent(true);
                setCurrentTimeMillis(currentTimeMillis);
                setCouponList(newCouponList || []);
            }
            catch (e) {
                _raptorReport.reportLog('神券预发券报错', e, {
                    level: 'warn'
                });
            }
        }
    });
    const updateCouponList = (addList, addStart, deleteNum) => {
        var _a;
        const listIsArr = Array.isArray(addList);
        const filterKey = (_a = Object.keys(addStart || {})) === null || _a === void 0 ? void 0 : _a[0];
        const filterValue = filterKey ? addStart[filterKey] : '';
        const isAddStartValid = !!filterKey;
        const isDeleteNumValid = typeof deleteNum === 'number';
        if (!listIsArr && !filterKey) {
            return initData();
        }
        if (listIsArr && isDeleteNumValid && isAddStartValid) {
            setCouponList(prevList => {
                const startIndex = prevList.findIndex((coupon) => coupon[filterKey] === filterValue);
                if (typeof startIndex === 'number' && startIndex > -1) {
                    const newList = [...prevList];
                    newList.splice(startIndex, deleteNum, ...addList);
                    return newList;
                }
                return prevList;
            });
        }
    };
    const updateAllCouponList = (list) => {
        setCouponList([...list]);
    };
    useEffect(() => {
        initData();
        warmUpByBundleNamesFn();
    }, []);
    const componentAppear = () => {
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(lxBidConfig.componentMV, {
            valLab: {
                custom: {
                    hotel_channel: hotelchannel || -999,
                    click_biz_line: bizLine
                }
            }
        });
    };
    return <Sensor x-if={showComponent && (couponList || []).length} onAppear={componentAppear} once={true}>
      <View className="magicmember-container">
        <LinearGradient x-if={isShowContainer && (bgColor || []).length} start={{
            x: 0,
            y: 0
        }} end={{
            x: 1,
            y: 1
        }} colors={bgColor} className="magicmember-container-bg">
          <Header title={(title || '').slice(0, 12)} titleColor={titleColor} secondEntryColor={secondEntryColor} secondEntryLink={secondEntryLink} secondEntryText={secondEntryText}/>
          <CouponList location={realLocation} updateCouponList={updateCouponList} currentTimeMillis={currentTimeMillis} amountColor={amountColor} isShowContainer={isShowContainer} couponList={sortedCouponList} toastConfig={toastConfig} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={bizLine} hotelchannel={hotelchannel} enableHorizontalScroll={enableHorizontalScroll}/>
        </LinearGradient>
        <CouponList x-else updateCouponList={updateCouponList} location={realLocation} toastConfig={toastConfig} currentTimeMillis={currentTimeMillis} amountColor={amountColor} isShowContainer={isShowContainer} couponList={sortedCouponList} formatCouponConfigRes={formatCouponConfigRes} setCurrentTimeMillis={setCurrentTimeMillis} bizLine={bizLine} hotelchannel={hotelchannel} enableHorizontalScroll={enableHorizontalScroll}/>
        {showAllCalimBtn && <AllClaimButton couponList={couponList} location={realLocation} couponConfig={couponConfig} toastConfig={toastConfig} updateCouponList={updateAllCouponList} setCurrentTimeMillis={setCurrentTimeMillis} formatCouponConfigRes={formatCouponConfigRes} allCouponText={allCouponText} allCouponColor={allCouponColor} allCouponTextColor={allCouponTextColor}/>}
      </View>
    </Sensor>;
};
export default memo(MagicmemberCoupon);
